import React, { useEffect, useRef, useState } from "react";
import ReactTooltip from "react-tooltip";
import Highlighter from "react-highlight-words";
import ReactPaginate from "react-paginate";
import Draggable from "react-draggable";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import actions from "../actions";
import RecommendationLogDetails from "./RecommendationLogDetail";
import Portal from "../../common/components/Portal";
import Loader from "../../common/components/Loader";
import LoadingOverlay from "react-loading-overlay";
import { recommendationsLogTableData } from "../../../config/tableData";
import Table from "../../common/components/Table";
import _ from "lodash";
import TableTopIcons from "../../common/components/TableTopIcons";
import { checkPermission } from "../../../config/utils";

const LOG_DATE_WILDCARD_KEY = "recommendation_versions.created_at";

const RecommendationLog = props => {
    const dispatch = useDispatch();
    const [RecommendationLogView, setRecommendationLogView] = useState(null);
    const [paginationParams, setPaginationParams] = useState({
        limit: 40,
        offset: 1,
        order: null,
        filters: {}
    });
    const [tableData, setTableData] = useState({
        keys: _.cloneDeep(recommendationsLogTableData.keys),
        config: _.cloneDeep(recommendationsLogTableData.config),
        data: []
    });
    const [commonFilters, setCommonFilters] = useState({});
    const { getAllRecommendationslogResponse, getListForRecommendationCommonFilterResponse, exportlogDataResponse } = useSelector(
        state => state?.recommendationsReducer
    );
    const [showWildCard, setShowWildCard] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    useEffect(() => {
        dispatch(
            actions?.getRecommendationsLog({
                ...props?.updatedParams,
                ...paginationParams,
                search: paginationParams?.search || props?.updatedParams?.search
            })
        );
    }, [paginationParams]);
    useEffect(() => {
        if (getAllRecommendationslogResponse?.success) {
            const flattenedData = (getAllRecommendationslogResponse?.versions ?? [])?.map((item, index) => ({
                id: item?.recommendation_version_id ?? index + 1,
                region: item?.recommendation?.region_name ?? "",
                site: item?.recommendation?.site_name ?? "",
                building: item?.recommendation?.building_name ?? "",
                ...item
            }));
            setTableData({ ...tableData, data: flattenedData ?? [] });
        }
    }, [getAllRecommendationslogResponse]);
    const renderRecommendationDetailModal = () => {
        if (!RecommendationLogView) return null;
        return (
            <Portal
                body={
                    <RecommendationLogDetails
                        normal_recom_grouping={props?.normal_recom_grouping}
                        onCancel={() => setRecommendationLogView(null)}
                        logDatail={RecommendationLogView}
                        columnConfig={props.columnConfig}
                    />
                }
                onCancel={() => setRecommendationLogView(null)}
            />
        );
    };
    const showInfoPage = (id, projectId, rowData) => {
        setRecommendationLogView({
            recom_id: rowData?.recommendation?.id,
            user_name: rowData.user?.name,
            user_id: rowData.user?.id,
            recom_code: rowData?.recommendation?.code ?? "",
            recom_desc: rowData?.recommendation?.description ?? "",
            region: rowData?.recommendation?.region_name ?? "",
            site: rowData?.recommendation?.site_name ?? "",
            building: rowData?.recommendation?.building_name ?? ""
        });
    };
    const updateTableSortFilters = async searchKey => {
        if (paginationParams?.order) {
            setPaginationParams({
                ...paginationParams,
                order: {
                    ...paginationParams?.order,
                    [searchKey]: paginationParams.order[searchKey] === "desc" ? "asc" : "desc"
                }
            });
        } else {
            setPaginationParams({
                ...paginationParams,
                order: { [searchKey]: "asc" }
            });
        }
    };
    const getListForCommonFilter = async params => {
        const { searchKey, ...rest } = params;
        const { limit, offset, ...paramRest } = props?.updatedParams;
        const { limit: paginationLimit, offset: paginationOffset, [searchKey]: removedKey, ...restPagination } = paginationParams;
        dispatch(
            actions.getListForCommonFilterRecommendationLog({
                ...paramRest,
                ...rest,
                ...restPagination,
                ...(params?.field === "recommendation.code" ? { limit: 100, offset: 1 } : {})
            })
        );
        return [];
    };
    const updateCommonFilter = async (list, exportFilters) => {
        setPaginationParams(prevPaginationParams => ({
            ...props?.updatedParams,
            ...prevPaginationParams,
            offset: 1,
            list: { ...props?.updatedParams?.list },
            recommendation_ids: exportFilters?.recommendation_ids ? exportFilters.recommendation_ids : [],
            user_ids: exportFilters?.user_ids ? exportFilters.user_ids : [],
            count_ids: exportFilters?.count_ids ? exportFilters.count_ids : [],
            region_ids: exportFilters?.region_ids ? exportFilters.region_ids : [],
            site_ids: exportFilters?.site_ids ? exportFilters.site_ids : [],
            building_ids: exportFilters?.building_ids ? exportFilters.building_ids : []
        }));
        setCommonFilters(prevCommonFilters => ({ ...prevCommonFilters, ...list }));
    };
    const handleGlobalSearch = async search => {
        setPaginationParams(prevParams => ({
            ...prevParams,
            offset: 1,
            limit: 40,
            search: search
        }));
    };
    const resetAllFilters = async () => {
        setPaginationParams(prevParams => ({
            limit: 40,
            offset: 1,
            search: "",
            order: prevParams?.order,
            ...props?.updatedParams
        }));
        setCommonFilters({});
        setSelectedRowId(null);
    };
    const resetAll = async () => {
        setPaginationParams(prevParams => ({
            // ...prevParams,
            limit: 40,
            offset: 1,
            search: "",
            list: {},
            filters: {},
            order: null,
            ...props?.updatedParams
        }));
        setCommonFilters({});
        setSelectedRowId(null);
    };

    const resetSort = async () => {
        setPaginationParams(prevParams => ({
            ...prevParams,
            order: null,
            limit: 40,
            offset: 1
        }));
    };
    const exportTableXl = () => {
        dispatch(
            actions?.logExport({
                ...props?.updatedParams,
                ...paginationParams,
                search: paginationParams?.search || props?.updatedParams?.search
            })
        );
    };
    const toggleWildCardFilter = () => {
        setShowWildCard(!showWildCard);
    };
    const updateWildCardFilter = newFilter => {
        setPaginationParams({ ...paginationParams, filters: newFilter });
    };
    const updateSelectedRow = async rowId => {
        setSelectedRowId(rowId);
    };

    const handleLogDateFilterChange = value => {
        setPaginationParams(prev => {
            const updatedFilters = { ...(prev.filters || {}) };
            if (!value?.filter) {
                delete updatedFilters[LOG_DATE_WILDCARD_KEY];
            } else {
                updatedFilters[LOG_DATE_WILDCARD_KEY] = value?.filter;
            }
            return {
                ...prev,
                offset: 1,
                filters: updatedFilters
            };
        });

    };
    return (
        <React.Fragment>
            <div
                className="modal assign-init-modal image-pull-modal log-mdl logs-modal-outer"
                style={{ display: "block" }}
                id="modalId"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <Draggable handle=".draggable-fav-modal" cancel=".close">
                    <div className="modal-dialog assignModal" role="document">
                        <LoadingOverlay active={getAllRecommendationslogResponse?.isLoading} spinner={<Loader />} fadeSpeed={10}>
                            <div className="modal-content">
                                <div className="modal-header draggable-fav-modal draggable pad-heading">
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        Logs
                                    </h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => props.onCancel()}>
                                        <span aria-hidden="true">
                                            <img src="/img/close.svg" alt="" />
                                        </span>
                                    </button>
                                </div>
                                <div className="modal-body ">
                                    <div className="dashboard-outer">
                                        <div className="outer-detail logs-outer">
                                            <div className="right-panel-section">
                                                <div className="dtl-sec log">
                                                    <div className="tab-dtl region-mng">
                                                        <div className="tab-active buildng-tb">
                                                            <div className="log-table build-table p-3 pt-0">
                                                                <div className="table-top-menu allign-right">
                                                                    <div className="rgt">
                                                                        <TableTopIcons
                                                                            tableData={tableData}
                                                                            hasGlobalSearch={true}
                                                                            hasWildCardFilter={true}
                                                                            hasView={false}
                                                                            isRecommendationLog={true}
                                                                            handleGlobalSearch={handleGlobalSearch}
                                                                            resetSort={resetSort}
                                                                            resetAllFilters={resetAllFilters}
                                                                            globalSearchKey={paginationParams.search}
                                                                            tableParams={paginationParams}
                                                                            isExport={checkPermission("forms", "recommendations", "export")}
                                                                            exportTableXl={() => exportTableXl()}
                                                                            tableLoading={exportlogDataResponse?.isLoading || false}
                                                                            toggleWildCardFilter={toggleWildCardFilter}
                                                                            filterDate={paginationParams?.filters?.[LOG_DATE_WILDCARD_KEY]}
                                                                            handleLogDateFilterChange={handleLogDateFilterChange}
                                                                            hasDateFilter
                                                                            resetAll={resetAll}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <Table
                                                                    hasViewIcon={true}
                                                                    tableData={tableData}
                                                                    hasEdit={false}
                                                                    hasDelete={false}
                                                                    hasInfoPage={true}
                                                                    showInfoPage={showInfoPage}
                                                                    updateSelectedRow={updateSelectedRow}
                                                                    hasSort={true}
                                                                    tableParams={paginationParams}
                                                                    updateTableSortFilters={updateTableSortFilters}
                                                                    isRecommendationLog={true}
                                                                    getListForCommonFilter={getListForCommonFilter}
                                                                    commonFilterData={getListForRecommendationCommonFilterResponse}
                                                                    isNewTableFilters={true}
                                                                    updateCommonFilter={updateCommonFilter}
                                                                    commonFilter={commonFilters}
                                                                    exportFilters={{
                                                                        recommendation_ids: paginationParams?.recommendation_ids || [],
                                                                        user_ids: paginationParams?.user_ids || [],
                                                                        count_ids: paginationParams?.count_ids || [],
                                                                        region_ids: paginationParams?.region_ids ? paginationParams.region_ids : [],
                                                                        site_ids: paginationParams?.site_ids ? paginationParams.site_ids : [],
                                                                        building_ids: paginationParams?.building_ids
                                                                            ? paginationParams.building_ids
                                                                            : []
                                                                    }}
                                                                    showWildCardFilter={showWildCard}
                                                                    updateWildCardFilter={updateWildCardFilter}
                                                                    wildCardFilter={paginationParams?.filters}
                                                                    selectedRowId={selectedRowId}
                                                                />
                                                            </div>
                                                            {getAllRecommendationslogResponse?.versions &&
                                                            getAllRecommendationslogResponse?.versions?.length > 0 ? (
                                                                <div className="table-bottom d-flex">
                                                                    <div className="count d-flex col-md-6">
                                                                        <div className="count-dtl">
                                                                            Total Count: <span>{getAllRecommendationslogResponse?.count}</span>
                                                                        </div>
                                                                        <div className="col-md-2 pr-2 selbx">
                                                                            <select
                                                                                className="form-control"
                                                                                value={paginationParams.limit}
                                                                                onChange={e => {
                                                                                    setPaginationParams({
                                                                                        offset: 1,
                                                                                        limit: e.target.value && parseInt(e.target.value)
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <option value="10">10</option>
                                                                                <option value="20">20</option>
                                                                                <option value="30">30</option>
                                                                                <option value="40">40</option>
                                                                                <option value="60">60</option>
                                                                                <option value="100">100</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <div className="pagination-sec col-md-6">
                                                                        <ReactPaginate
                                                                            previousLabel={
                                                                                <span
                                                                                    data-place="top"
                                                                                    data-effect="solid"
                                                                                    data-tip={`Previous`}
                                                                                    data-background-color="#007bff"
                                                                                >
                                                                                    &lt;
                                                                                </span>
                                                                            }
                                                                            nextLabel={
                                                                                <span
                                                                                    data-place="top"
                                                                                    data-effect="solid"
                                                                                    data-tip={`Next`}
                                                                                    data-background-color="#007bff"
                                                                                >
                                                                                    &gt;
                                                                                </span>
                                                                            }
                                                                            breakLabel={"..."}
                                                                            breakClassName={"break-me"}
                                                                            pageCount={Math.ceil(
                                                                                getAllRecommendationslogResponse?.count / paginationParams?.limit
                                                                            )}
                                                                            marginPagesDisplayed={2}
                                                                            pageRangeDisplayed={5}
                                                                            onPageChange={page => {
                                                                                setPaginationParams({
                                                                                    ...paginationParams,
                                                                                    offset: page?.selected ? page?.selected + 1 : 1
                                                                                });
                                                                            }}
                                                                            containerClassName={"pagination"}
                                                                            subContainerClassName={"pages pagination"}
                                                                            activeClassName={"active"}
                                                                            activeLinkClassName={"active"}
                                                                            forcePage={paginationParams.offset ? paginationParams.offset - 1 : 1}
                                                                        />
                                                                        <ReactTooltip />
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </LoadingOverlay>
                    </div>
                </Draggable>
            </div>
            {renderRecommendationDetailModal()}
        </React.Fragment>
    );
};

export default RecommendationLog;
